// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"469e0d9f","285":"a755e150","631":"ee1a4603","760":"31830b40","774":"1f9e9216","819":"9427e7aa","851":"b94cc816"}[chunkId] + ".chunk.js";
};